import { useQuery } from '@tanstack/react-query'

import { axios } from 'Lib/axios'
import { QueryConfig, ExtractFnReturnType } from 'Lib/react-query'

import { VisitsSummary, dashboardSummaryParams } from './types'
import { useUserStore } from 'Stores/userStoreModuleFed'

export type QueryFnType = typeof getVisitsSummary

export const getVisitsSummary = async (
  accountId: number,
  userId: number,
  params?: dashboardSummaryParams
): Promise<VisitsSummary[] | Error> => {
  return axios
    .post<{ data: VisitsSummary[] | Error }>(
      `/users/${userId}/accounts/${accountId}/dashboard/get-visits`,
      params
    )
    .then((result) => result.data.data)
}

export const useVisitsSummary = (
  params?: dashboardSummaryParams,
  enabled?: boolean,
  { config }: { config?: QueryConfig<QueryFnType> } = {}
) => {
  const { accountId, userId, subscriptionId } = useUserStore()
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [
      'getVisitsSummaryGW',
      [
        accountId,
        params?.startDate,
        params?.endDate,
        params?.domains,
        params?.campaigns,
        params?.platforms,
      ],
    ],
    queryFn: () => getVisitsSummary(accountId, userId, params),
    enabled: enabled || !!(!!accountId && !!subscriptionId),
    ...config,
  })

  const data = query.data instanceof Error ? undefined : query.data

  return { ...query, data }
}
